import React from 'react';

const TranslateContext = React.createContext((value) => value);

export default TranslateContext;
